import { render, staticRenderFns } from "./budokai_list.vue?vue&type=template&id=51c1ba94&scoped=true"
import script from "./budokai_list.vue?vue&type=script&lang=js"
export * from "./budokai_list.vue?vue&type=script&lang=js"
import style0 from "./budokai_list.vue?vue&type=style&index=0&id=51c1ba94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c1ba94",
  null
  
)

export default component.exports